import dayjs from 'dayjs';

import { blue, green } from '@mui/material/colors';

import { fNumber, fCurrency } from 'src/utils/format-number';

import { ReportCard } from 'src/components/Reports/ReportCard';

import { StoreSalesChart } from '../../Summary/layout/StoreSalesChart';

export function CustomerTrendsChart({
  dataset,
  title,
  subtitle,
  loading,
  currency,
  categories,
  dateFormatter = (value: string) => dayjs(value).format('MMM YY'),
}: {
  dataset: any[];
  categories: string[];
  title: string;
  loading?: boolean;
  subtitle?: string;
  currency?: boolean;
  dateFormatter?: (value: string) => string;
}) {
  const formatter = currency ? fCurrency : fNumber;
  return (
    <ReportCard
      loading={loading}
      title={title}
      subheader={subtitle}
      renderChart={() =>
        !dataset ? null : (
          <StoreSalesChart
            type="line"
            chart={{
              series: dataset,
              options: {
                colors: [green[500], blue[200]],
                legend: { show: true },
                plotOptions: {
                  bar: {
                    distributed: false,
                  },
                },

                dataLabels: {
                  enabled: false,
                },
                chart: { type: 'line', sparkline: { enabled: false } },
                xaxis: {
                  categories,
                  labels: {
                    formatter: dateFormatter,
                  },
                },
                yaxis: { labels: { formatter: (value: number) => formatter(value) } },
                tooltip: {
                  y: {
                    formatter: (value: number) => `${formatter(value)}`,
                  },
                },
              },
            }}
            sx={{
              pl: 1,
              py: 2.5,
              pr: 2.5,
              width: '100%',
              height: 500,
            }}
          />
        )
      }
    />
  );
}
